import { useAnalytics } from "./useAnalytics";

export const calMappings: Record<string, string> = {
  audit: "https://cal.com/xpirience/audit",
  accompagnement: "https://cal.com/xpirience/accompagnement",
  developpement: "https://cal.com/xpirience/developpement",
  kanzen: "https://cal.com/xpirience/kanzen",
  kanzenesn: "https://cal.com/xpirience/kanzenesn",
  kanzenfiduciaire: "https://cal.com/xpirience/kanzenfiduciaire",
};

export const useCalCom = () => {
  const isOpen = useState("calcom-modal-open", () => false);
  const bookingUrl = useState(
    "calcom-booking-url",
    () => "https://cal.com/xpirience/kanzen",
  );

  const { trackAppointmentModalOpen } = useAnalytics();

  const openModal = (urlOrType?: string) => {
    if (urlOrType && typeof urlOrType === "string") {
      // If it's a known key, use the mapping, otherwise use as raw URL
      bookingUrl.value = calMappings[urlOrType] || urlOrType;
    } else {
      bookingUrl.value = calMappings.kanzen;
    }

    trackAppointmentModalOpen(bookingUrl.value);
    isOpen.value = true;
  };

  const closeModal = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    bookingUrl,
    openModal,
    closeModal,
  };
};
